import React from 'react';
import { useMoneyFormat } from '../../context/LocaleContext';
import { balanceView } from '../../domain/familyAccount';
import s from './families.module.css';

// A family's balance, which reads three ways: they owe you, you owe them, or it
// is settled. Shared so the list and the detail header agree. The three
// readings are `balanceView` (src/domain/familyAccount.js).
export default function FamilyBalance({ minor }) {
  const formatMoney = useMoneyFormat();
  const view = balanceView(minor);
  if (view.tone === 'owe') return <span className={s.owe}>{formatMoney(view.minor)}</span>;
  if (view.tone === 'credit') return <span className={s.credit}>{formatMoney(view.minor)}{view.suffix}</span>;
  return <>{formatMoney(0)}</>;
}
